export const getStatusBadgeClass = (status?: string): string => {
  const statusLower = status?.toLowerCase().replace(/\s+/g, "-");

  // Define reusable color variants
  const colors = {
    blue: "bg-blue-100 text-blue-800 border-blue-200",
    yellow: "bg-yellow-100 text-yellow-800 border-yellow-200",
    orange: "bg-orange-100 text-orange-800 border-orange-200",
    purple: "bg-purple-100 text-purple-800 border-purple-200",
    green: "bg-green-100 text-green-800 border-green-200",
    red: "bg-red-100 text-red-800 border-red-200",
    gray: "bg-gray-100 text-gray-800 border-gray-200",
  };

  // Map statuses & priorities to a color key
  const statusMap: Record<string, keyof typeof colors> = {
    // --- existing statuses ---
    created: "blue",
    pending: "yellow",
    "in-progress": "orange",
    "in-review": "purple",
    completed: "green",
    approved: "green",
    cancelled: "red",
    canceled: "red",
    rejected: "red",
    "on-hold": "gray",
    excellent: "green",
    good: "blue",
    fair: "yellow",
    poor: "red",
    critical: "red",
    assigned: "blue",
    pass: "green",
    rcnt: "yellow",
    fail: "red",
    scheduled: "yellow",
    unscheduled: "blue",
    normal: "green",
    faulty: "red",
    // --- priorities ---
    low: "green",
    medium: "yellow",
    high: "orange",
    active: "green",
    overdue: "red",
  };

  return colors[statusMap[statusLower] || "gray"];
};

